import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]
  static classes = ["active", "inactive"]

  select(event) {
    // Remove highlight from all chat items
    this.itemTargets.forEach(item => {
      item.classList.remove(...this.activeClasses)
      item.classList.add(...this.inactiveClasses)
    })

    // Add highlight to clicked chat item
    const clickedItem = event.currentTarget
    clickedItem.classList.remove(...this.inactiveClasses)
    clickedItem.classList.add(...this.activeClasses)
  }

  connect() {
    // On page load, highlight the chat that matches current URL
    const currentPath = window.location.pathname
    this.itemTargets.forEach(item => {
      const href = item.getAttribute("href")
      if (href === currentPath) {
        item.classList.remove(...this.inactiveClasses)
        item.classList.add(...this.activeClasses)
      }
    })
  }
}
